import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { CurrentSessionData } from "src/model/class/general classes/current-session-data";
import { Plant } from "src/model/class/general classes/plant";
import { BIGDeviceOperationMode } from "src/components/shared-components/enum/enumDevice";
import { GenericUserData } from "src/model/interface/generic-user-data";
import { HistoryTransit } from "src/model/interface/history-transit";
import { currentUserData } from "./authentication.selectors";
import { selectedPlant } from "./plant.selectors";

/**
 * Selector for list history transit
 */
export const listHistoryTransit = createFeatureSelector<Array<HistoryTransit>>(
  AppSettings.KEY_HISTORY_TRANSIT
);

/**
 * Selector to get first transit to send
 */
export const currentHistoryTelegramToSend = createSelector(
  selectedPlant,
  currentUserData,
  listHistoryTransit,

  (
    selectedPlant: Plant,
    currentUserData: GenericUserData,
    listHistoryTransit: Array<HistoryTransit>
  ) => {
    let currrentHistoryTransitToSend: HistoryTransit = null;

    if (
      selectedPlant &&
      currentUserData?.currentUser &&
      listHistoryTransit.length > 0
    ) {
      if (
        selectedPlant.operativeMode ===
        BIGDeviceOperationMode.ACCESS_CONTROL_MODE ||
        selectedPlant.operativeMode ===
        BIGDeviceOperationMode.DIGITAL_PLACE_MODE
      ) {
        currrentHistoryTransitToSend =
          listHistoryTransit.filter(
            (historyTransit: HistoryTransit) =>
              historyTransit.idPlant === selectedPlant.ID
          )?.[0] || null;
      }
    }

    return currrentHistoryTransitToSend;
  }
);
